import { useSearchParams } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { ContactForm, SERVICE_OPTIONS } from "@/components/contact/ContactForm";
import { ContactInfo } from "@/components/contact/ContactInfo";

export default function Contact() {
  const [params] = useSearchParams();
  const requested = params.get("service");
  const defaultService = SERVICE_OPTIONS.some((o) => o.value === requested) ? requested : undefined;

  return (
    <main data-testid="contact-page">
      <section className="mx-auto max-w-7xl px-6 pb-24 pt-24 lg:px-10 lg:pb-32 lg:pt-32">
        <Reveal>
          <p className="eyebrow text-primary">Contact Us</p>
          <h1 className="mt-6 max-w-3xl font-display text-4xl font-light leading-[1.05] tracking-tight text-foreground sm:text-5xl lg:text-6xl">
            Tell us about your system. We&rsquo;ll tell you what it needs.
          </h1>
          <p className="mt-6 max-w-xl text-base font-light leading-relaxed text-muted-foreground md:text-lg">
            Whether a manufacturer referred you to us, your installer has disappeared, your roof needs replacing, or your
            business needs a trusted field partner &mdash; the inquiry form is the fastest way to reach our service team.
            Every submission is reviewed and answered.
          </p>
        </Reveal>

        <div className="mt-16 grid gap-10 lg:grid-cols-12">
          <Reveal delay={0.1} className="lg:col-span-7">
            <ContactForm key={defaultService || "default"} defaultService={defaultService} />
          </Reveal>
          <Reveal delay={0.2} className="lg:col-span-5">
            <ContactInfo />
          </Reveal>
        </div>
      </section>
    </main>
  );
}
